// Locked/technical configuration for the SEO service landing pages.
// All EDITABLE marketing copy (h1, intro, highlights, FAQ, images, meta tags,
// button labels) now lives in the backend `seo_pages` collection, managed via
// Admin > Contenido de páginas SEO — fetched at runtime by <ServiceLandingPage />.
// This file only holds what must stay locked/code-controlled: the route (slug),
// the backend page_id, the quote-calculator category preset, the WhatsApp
// deep-link message template, and structural cross-links to other pages.

export const SERVICE_PAGES = [
  {
    slug: "/fotografo-bodas-queretaro",
    pageId: "fotografo-bodas-queretaro",
    serviceKey: "boda",
    ctaCategory: "bodas",
    whatsappMessage: "Hola, me interesa cotizar el servicio de fotografía de bodas en Querétaro.",
    related: [
      { label: "Fotografía y Video de Bodas", to: "/fotografia-video-bodas-queretaro" },
      { label: "Save the Date", to: "/save-the-date-queretaro" },
    ],
  },
  {
    slug: "/fotografia-video-bodas-queretaro",
    pageId: "fotografia-video-bodas-queretaro",
    serviceKey: "foto_video",
    ctaCategory: "foto_video",
    whatsappMessage: "Hola, me interesa cotizar el servicio de fotografía y video de bodas en Querétaro.",
    related: [
      { label: "Fotógrafo de Bodas", to: "/fotografo-bodas-queretaro" },
      { label: "Fotógrafo de XV Años", to: "/fotografo-xv-anos-queretaro" },
    ],
  },
  {
    slug: "/fotografo-xv-anos-queretaro",
    pageId: "fotografo-xv-anos-queretaro",
    serviceKey: "xv",
    ctaCategory: "xv",
    whatsappMessage: "Hola, me interesa cotizar el servicio de fotografía para XV años en Querétaro.",
    related: [
      { label: "Invitaciones Digitales", to: "/invitaciones-digitales" },
      { label: "Fotógrafo de Bodas", to: "/fotografo-bodas-queretaro" },
    ],
  },
  {
    slug: "/save-the-date-queretaro",
    pageId: "save-the-date-queretaro",
    serviceKey: "save_the_date",
    ctaCategory: "save_the_date",
    whatsappMessage: "Hola, me interesa cotizar una sesión de Save the Date en Querétaro.",
    related: [
      { label: "Fotógrafo de Bodas", to: "/fotografo-bodas-queretaro" },
      { label: "Invitaciones Digitales", to: "/invitaciones-digitales" },
    ],
  },
  {
    slug: "/invitaciones-digitales",
    pageId: "invitaciones-digitales",
    serviceKey: "invitacion_digital",
    ctaCategory: "invitacion_digital",
    whatsappMessage: "Hola, me interesa cotizar una invitación digital.",
    related: [
      { label: "Save the Date", to: "/save-the-date-queretaro" },
      { label: "Fotógrafo de XV Años", to: "/fotografo-xv-anos-queretaro" },
    ],
  },
  {
    slug: "/cabina-de-fotos-queretaro",
    pageId: "cabina-de-fotos-queretaro",
    serviceKey: "cabina_fotos",
    ctaCategory: "cabina_fotos",
    whatsappMessage: "Hola, me interesa cotizar una cabina de fotos para mi evento.",
    related: [
      { label: "Fotógrafo de Bodas", to: "/fotografo-bodas-queretaro" },
      { label: "Podcast de tu Boda", to: "/podcast-boda-queretaro" },
    ],
  },
  {
    slug: "/podcast-boda-queretaro",
    pageId: "podcast-boda-queretaro",
    serviceKey: "podcast_boda",
    ctaCategory: "podcast_boda",
    whatsappMessage: "Hola, me interesa cotizar el Podcast de mi boda.",
    related: [
      { label: "Fotógrafo de Bodas", to: "/fotografo-bodas-queretaro" },
      { label: "Cabina de Fotos", to: "/cabina-de-fotos-queretaro" },
    ],
  },
];

// Labels used only inside the admin editor (page selector) — cosmetic, not SEO copy.
export const SEO_PAGE_ADMIN_LABELS = {
  "fotografo-bodas-queretaro": "Fotografía de Bodas",
  "fotografia-video-bodas-queretaro": "Fotografía y Video de Bodas",
  "fotografo-xv-anos-queretaro": "Fotografía de XV Años",
  "save-the-date-queretaro": "Save the Date",
  "invitaciones-digitales": "Invitaciones Digitales",
  "cabina-de-fotos-queretaro": "Cabina de Fotos",
  "podcast-boda-queretaro": "Podcast de tu Boda",
};

export const findServicePage = (slug) => SERVICE_PAGES.find((p) => p.slug === slug);
